import { useDashboardGlobalContext } from '@/dashboards/providers/dashboardGlobalContext';
import { getROIConfig } from '@/dashboards/SpendSummary/utils';
import { useMemo } from 'react';

/**
 * The project's ROI flavour — its display name, description and calculator.
 *
 * Both the totals cards and the table need it, so each reads it here rather than
 * having it drilled through the section that renders them.
 */
export const useRoiConfig = () => {
    const {
        project: { roiType },
    } = useDashboardGlobalContext();

    return useMemo(() => getROIConfig(roiType), [roiType]);
};
